module.exports = __webpack_public_path__ + "img/manage-users.9de724b3.svg";